import { render, staticRenderFns } from "./wllz.vue?vue&type=template&id=cfe38754&scoped=true&"
import script from "./wllz.vue?vue&type=script&lang=js&"
export * from "./wllz.vue?vue&type=script&lang=js&"
import style0 from "./wllz.vue?vue&type=style&index=0&id=cfe38754&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe38754",
  null
  
)

export default component.exports